import React from 'react'

import { useDialogState } from '../components'
import { HelpDialog } from '../modals/help'
import { IdeasDialog, saveIdea } from '../modals/ideas'
import ChartLayout from '../models/chart_layout'

interface NoticeProps {
  layoutModel: ChartLayout
  handleAddNote: () => void
}

export default function Notice(props: NoticeProps) {
  const dialog = useDialogState()

  return (
    <>
      <div>
        <button
          className="btn is-primary"
          data-testid="charts-notice-ideas-save-btn"
          onClick={() => saveIdea(props.layoutModel)}
        >
          Save
        </button>
        <button className="btn" onClick={() => dialog.show()} data-testid="charts-notice-ideas-load-btn">
          Load
        </button>
        {window.FinvizSettings.hasUserPremium && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href="#"
            className="tab-link"
            onClick={(e) => {
              e.preventDefault()
              props.handleAddNote()
            }}
            data-testid="charts-notice-ideas-add-note-btn"
          >
            + Add a note
          </a>
        )}
      </div>
      <div>
        <HelpDialog hasNewQuoteMenu={window.FinvizSettings.hasUserPremium} />
      </div>
      <IdeasDialog state={dialog} />
    </>
  )
}
